// extracted by mini-css-extract-plugin
export default {"item":"SetGroup_item__WcaHD","icon":"SetGroup_icon__aboYA"};